import { useMutation } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { requestPayDriver } from "./payDriver.request";

const usePayDriver = (
  options?: MutationOptions<void, ApiServiceError<ApiError>>
) => {
  return useMutation({
    mutationFn: requestPayDriver,
    onError: toastServerError,
    ...options
  });
};

export default usePayDriver;
